import {CURRENCY_CONFIG} from './money.js';

export function convert(value, currency){
    var rate = CURRENCY_CONFIG.filter((c)=>{return c.type === currency;})[0];
    if(rate !== null && rate !== undefined){
        rate = rate.rate;
    } else {
        rate = 1;
    }
    return Math.round(value*rate*10000000)/10000000;
}


// WEBPACK FOOTER //
// ./src/components/currency.js